var React = require('react');

function Date (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H12C12.8284 2.5 13.5 3.17157 13.5 4V12C13.5 12.8284 12.8284 13.5 12 13.5H4C3.17157 13.5 2.5 12.8284 2.5 12V4Z","stroke":"currentColor","key":0}),React.createElement("line",{"x1":"2.5","y1":"5.5","x2":"13.5","y2":"5.5","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"5.5","y1":"3.5","x2":"5.5","y2":"1.5","stroke":"currentColor","strokeLinecap":"round","key":2}),React.createElement("line",{"x1":"10.5","y1":"3.5","x2":"10.5","y2":"1.5","stroke":"currentColor","strokeLinecap":"round","key":3})]);
}

Date.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Date;

Date.default = Date;
